var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import { getLinkTarget } from '../../utils/variations';
import { isFieldValid } from '../../utils/validation';
import { OnClickFocusWrapper } from '../UtilityWrappers';
const StyledLink = styled((_a) => {
    var { isSecondary, ariaLabel } = _a, others = __rest(_a, ["isSecondary", "ariaLabel"]);
    const newProps = ariaLabel ? Object.assign(Object.assign({}, others), { 'aria-label': ariaLabel }) : Object.assign({}, others);
    return React.createElement(Link, Object.assign({}, newProps));
}) `
  display: table;
  position: relative;
  font-family: ${({ theme }) => theme.fontFamilyHeading};
  font-size: 16px;
  background-color: ${({ theme }) => theme.buttonPrimaryColor};
  color: ${({ theme }) => theme.buttonPrimaryTextColor};
  border: 2px solid ${({ theme }) => theme.buttonPrimaryColor};

  padding: 0 28px;
  height: 44px;
  text-align: center;
  transition: 0.25s ease-out;
  cursor: pointer;

  &:active,
  &:hover {
    background-color: ${({ theme }) => theme.buttonPrimaryColorHover};
    border: 2px solid ${({ theme }) => theme.buttonPrimaryColorHover};
    color: ${({ theme }) => theme.buttonPrimaryTextColor};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.buttonPrimaryDisabledColor};
    border: 2px solid ${({ theme }) => theme.buttonPrimaryDisabledColor};
    pointer-events: none;
  }

  ${({ isSecondary }) => isSecondary &&
    css `
      color: ${({ theme }) => theme.buttonSecondaryTextColor};
      background-color: ${({ theme }) => theme.buttonSecondaryColor};
      border: ${({ theme }) => theme.buttonSecondaryBorder};

      &:active,
      &:hover {
        background-color: ${({ theme }) => theme.buttonSecondaryColorHover};
        color: ${({ theme }) => theme.buttonSecondaryTextColor};
      }

      &:disabled {
        background-color: ${({ theme }) => theme.buttonSecondaryDisabledColor};
        border: ${({ theme }) => theme.buttonSecondaryDisabledBorder};
      }
    `}
`;
const Label = styled.span `
  display: table-cell;
  vertical-align: middle;
`;
export const ButtonLink = (_a) => {
    var { field, textField, isSecondary, disabled, isNotTabbable } = _a, rest = __rest(_a, ["field", "textField", "isSecondary", "disabled", "isNotTabbable"]);
    if (!isFieldValid(field, 'href') && !isFieldValid(textField))
        return null;
    const { linktype, text: ariaLabel } = field && field.value;
    const text = textField && textField.value;
    return (React.createElement(OnClickFocusWrapper, null,
        React.createElement(StyledLink, Object.assign({ field: field, disabled: disabled, isSecondary: isSecondary, target: getLinkTarget(linktype), tabIndex: isNotTabbable ? -1 : 0, ariaLabel: ariaLabel }, rest),
            React.createElement(Label, null, text))));
};
